<div id="SL11" class="block white">
    <div class="principalContainer">
      <div  style="margin-bottom: 24px;">
        <h1 class="display_xl" data-aos="fade-up">{{ package.title001 | uppercase }}</h1>
      </div>
      <div class="row">
        <div class="column" *ngFor="let item of package.elements">
          <img [src]="item.img" alt="Elemento" class="image-class"/>
        </div>
      </div>
    </div>
  </div>
  